import { render, staticRenderFns } from "./AssociateUser.vue?vue&type=template&id=63bcc852&"
import script from "./AssociateUser.vue?vue&type=script&lang=js&"
export * from "./AssociateUser.vue?vue&type=script&lang=js&"
import style0 from "./AssociateUser.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports